var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainPageFooter"},[_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.handleJoinEvent}},[_c('img',{attrs:{"src":require("../assets/images/goLive_Icon.png")}}),_vm._v("\n    "+_vm._s(_vm.$t('goLive'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }